function productPriceController($scope) {
    const $ctrl = this;
    // set default bindings
    $scope.vm.dollar = '';
    $scope.vm.cents = '';

    function convertDisplayPrice(price) {
        if (typeof price !== 'number') {
            return {};
        }

        const priceParts = price.toFixed(2).split('.');

        return {
            dollar: priceParts[0],
            cents: priceParts[1]
        };
    }

    $ctrl.$onInit = function() {
        const {
            dollar = '',
            cents = ''
        } = convertDisplayPrice($scope.vm.price);

        $scope.vm.dollar = dollar;
        $scope.vm.cents = cents;
    };
 }

 module.exports = {
    bindings: {
        price: '<'
    },
    controllerAs: 'vm',
    controller: [
        '$scope',
        productPriceController
    ],
    template: require('./receipt-rewards-price.html')
 };



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/receipt-rewards/receipt-rewards-price.js
 **/